import * as React from "react";
import { Children } from "react";
import { styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

import { Grid } from "../../elements/grid";

export const Field = styled.div<{ $flex?: string }>`
  margin-bottom: 2.5rem;
  position: relative;
  ${({ $flex }) => $flex && `flex: ${$flex}`};
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  * {
    margin: 0;

    &:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;

const ValidationErrorElement = styled.div`
  ${typeScale.sm}

  color: ${(props) => props.theme.colours.error};
  font-weight: bold;

  &:not(:empty) {
    padding-top: 0.5rem;
  }
`;

export const ValidationError: React.FC<React.PropsWithChildren> = ({ children }) => {
  const errors = Children.map(children, (child) => <div>{child}</div>);
  return (
    <ValidationErrorElement>
      <Grid $tight>{errors}</Grid>
    </ValidationErrorElement>
  );
};

export const ButtonGroup = styled.footer`
  display: flex;
  justify-content: flex-end;

  *:not(:first-of-type) {
    margin-left: 1rem;
  }
`;
